<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
  <div class="page-container">
    <div class="logo-div-container">
        <div>
            <div class="logo-container">
                <img class="main-logo side-logo" :src="pearsonLogoUrl()" width="212px" />
             </div>
            <div class="logo-text">
                <span>{{$t('pages.selfservice.forgotUsername.welcomeText')}}</span>
            </div>
        </div>

    </div>
    <fr-center-card class="pearson-card" :showLogo="false" v-if="selfServiceType !== null">
        <div slot="center-card-header">
            <a class="back" @click="backUrl" href="#">{{$t('pages.selfservice.forgotUsername.returnToSignInAnchorText')}}</a>
            <h2 class="h2">{{$t(`pages.selfservice.headers.username.title`)}}</h2>
        </div>

        <b-card-body slot="center-card-body">
            <component ref="selfServiceStage"
                :is="selfServiceType"
                :selfServiceDetails="selfServiceDetails"
                @advanceStage="advanceStage"
                :apiType="apiType">
            </component>
        </b-card-body>

    </fr-center-card>

    <b-container fluid class="h-100 px-0"  v-else>
        <div class="h-100 d-flex">
            <div class="m-auto fr-center-card">
                <bounce-loader :color="loadingColor"></bounce-loader>
            </div>
        </div>
        <fr-center-card class="pearson-card" :showLogo="false" v-if="selfServiceType !== null">
            <div slot="center-card-header">
                <h2 class="h2">{{$t(`pages.selfservice.headers.username.title`)}}</h2>
            </div>

            <b-card-body slot="center-card-body">
                <component ref="selfServiceStage"
                    :is="selfServiceType"
                    :selfServiceDetails="selfServiceDetails"
                    @advanceStage="advanceStage"
                    :apiType="apiType">
                </component>
            </b-card-body>
        </fr-center-card>

        <b-container fluid class="h-100 px-0"  v-else>
            <div class="h-100 d-flex">
                <div class="m-auto fr-center-card">
                    <bounce-loader :color="loadingColor"></bounce-loader>
                </div>
            </div>
        </b-container>
    </b-container>
</div>
</template>

<script>
import _ from 'lodash';
import { BounceLoader } from 'vue-spinner/dist/vue-spinner.min.js';
import styles from '@/scss/theme-variables.scss';
import CenterCard from '@/components/utils/CenterCard';
import Captcha from '@/components/selfservice/common/Captcha';
import EmailUsername from '@/components/selfservice/forgotusername/EmailUsername';
import GenericSelfService from '@/components/selfservice/common/GenericSelfService';
import RetrieveUsername from '@/components/selfservice/forgotusername/RetrieveUsername';
import SelfserviceAPI from '@/components/selfservice/mixins/SelfserviceAPIMixin';
import UserQuery from '@/components/selfservice/forgotusername/ForgotUsername';
import { getClientById, CLIENT } from '../../../lib/getClientById';

/**
 * @description Selfservice controlling component for retrieving a forgotten username. Makes use of selfservice-username.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 */
export default {
    name: 'Forgot-Username',
    components: {
        Captcha,
        EmailUsername,
        RetrieveUsername,
        UserQuery,
        GenericSelfService,
        'bounce-loader': BounceLoader,
        'fr-center-card': CenterCard
    },
    data () {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            loadingColor: styles.baseColor,
            apiType: 'username'
        };
    },
    mounted () {
        /* istanbul ignore next */
        this.loadData();
    },
    methods: {
        backUrl (event) {
            event.preventDefault();
            window.history.back();
        },
        setChildComponent (type, details) {
            this.selfServiceDetails = details;

            let stageCheck = false;

            _.each(this.$options.components, (value, key) => {
                if (_.toLower(key) === _.toLower(type)) {
                    stageCheck = true;
                }
            });

            if (stageCheck) {
                this.selfServiceType = type;
            } else {
                this.selfServiceType = 'GenericSelfService';
            }
        },
        apiErrorCallback (error) {
            /* istanbul ignore next */
            window.gaEvent('Forgot username', 'Forgot username', 'Failed', error.response.data.message);
            this.setChildComponent('retrieveUsername', { error: error.response.data.message });
        },
        pearsonLogoUrl () {
            var realm;
            var clientId = getClientById();
            if (clientId === CLIENT.REVIBE) {
                return require('@/assets/images/Revibe-logo.png');
            }
            if (this.$route.query.realm === undefined && localStorage.realm === undefined) {
                localStorage.realm = 'PEARSON';
                realm = 'PEARSON';
            } else if (this.$route.query.realm !== undefined) {
                localStorage.realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
                realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
            } else if (localStorage.realm !== undefined) {
                realm = localStorage.realm;
            }
            if (realm === 'PEARSONCOLLEGELONDON') {
                return require('@/assets/images/pcl_white.png');
            } else {
                return require('@/assets/images/PearsonLogo_Horizontal_Blk_RGB.png');
            }
        }
    },
    mixins: [
        SelfserviceAPI
    ]
};
</script>
<style scoped lang="scss">

.forgot-username-container{
    display: flex;
    flex-direction: row;
}
.h2 {
    font-size: 2rem;
    line-height: 2.71429rem;
    font-weight: lighter;
    color: #252525;
    font-family: "Open Sans Complete"
}
@import '../../../scss/pearson-common.css';
</style>
